<template>
  <div v-if="domiciliationBancaire">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ getTitle }}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <a class="button"
               @click="$router.go(-1)">
              {{ $t('addDomiciliationBancaire.actions.cancel') }}
            </a>
            <a class="button is-addOrEdit"
               @click="saveDomiciliationBancaire()">
              {{ $t('general.button.sauvegarder') }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <error-msg-component :messages="messages"
                         :messagesChampsVide="messagesChampsVide"
                         :champsVide="champsVide"
                         :error="error"
                         :title="'addDomiciliationBancaire.error.problemOccurred'"
                         :withEmplyFields="true"
                         @close="error = $event"/>
    <div class="columns mgt-20px">
      <div class="column is-12">
        <div class="card">
          <header class="header-card">
            <p>
              {{$t('addDomiciliationBancaire.informationDomiciliation.title')}}
            </p>
          </header>
          <div class="card-content">
            <div class="columns is-multiline">
              <div class="column is-6 is-paddingless">
                <b-field :label="$t('addDomiciliationBancaire.informationDomiciliation.libelle')"
                         class="obligatoire column is-12">
                  <b-input v-model="domiciliationBancaire.libelle"></b-input>
                </b-field>
              </div>
              <div class="column is-6 is-paddingless">
                <b-field
                  :label="$t('addDomiciliationBancaire.informationDomiciliation.libelleBanque')"
                  class="column is-12">
                  <b-input v-model="domiciliationBancaire.libelleBanque"></b-input>
                </b-field>
              </div>
              <div class="column is-6 has-background-background mgt-20px">
                <div class="columns is-multiline">
                  <b-field
                    :label="$t('addDomiciliationBancaire.informationDomiciliation.titulaire')"
                           class="column is-12 is-marginless">
                    <b-input v-model="domiciliationBancaire.titulaire"></b-input>
                  </b-field>
                  <div class="column is-12 is-marginless">
                    <input-iban
                              :label="$t('addDomiciliationBancaire.informationDomiciliation.iban')"
                              v-model="domiciliationBancaire.iban"/>
                  </div>
                  <b-field :label="$t('addDomiciliationBancaire.informationDomiciliation.bic')"
                           class="column is-12 is-marginless">
                    <b-input v-model="domiciliationBancaire.codeSwift"></b-input>
                  </b-field>
                  <b-field
                    :label="$t('addDomiciliationBancaire.informationDomiciliation.codeBanque')"
                    class="column is-3">
                    <b-input v-model="domiciliationBancaire.codeBanque"></b-input>
                  </b-field>
                  <b-field
                    :label="$t('addDomiciliationBancaire.informationDomiciliation.codeAgence')"
                    class="column is-3">
                    <b-input v-model="domiciliationBancaire.codeGuichet"></b-input>
                  </b-field>
                  <b-field
                    :label="$t('addDomiciliationBancaire.informationDomiciliation.numeroCompte')"
                    class="column is-3">
                    <b-input v-model="domiciliationBancaire.numeroCompte"></b-input>
                  </b-field>
                  <b-field
                    :label="$t('addDomiciliationBancaire.informationDomiciliation.cleRib')"
                    class="column is-3">
                    <b-input v-model="domiciliationBancaire.cleRib"></b-input>
                  </b-field>
                </div>
              </div>
              <div class="column is-6 mgt-20px">
                <div class="columns is-multiline">
                  <b-field
                    :label="$t('addDomiciliationBancaire.informationDomiciliation.compteComptable')"
                    class="column is-4 is-marginless">
                    <b-input v-model="domiciliationBancaire.numCpta"></b-input>
                  </b-field>
                  <b-field
                    :label="$t('addDomiciliationBancaire.informationDomiciliation.compteEscompte')"
                    class="column is-4 is-marginless">
                    <b-input v-model="domiciliationBancaire.compteEscompte"></b-input>
                  </b-field>
                  <b-field
                    :label="$t('addDomiciliationBancaire.informationDomiciliation.codeJournal')"
                    class="column is-4 is-marginless">
                    <b-input v-model="domiciliationBancaire.codeJournal"></b-input>
                  </b-field>
                  <b-field
                    :label="$t('addDomiciliationBancaire.informationDomiciliation.tvaSurEscompte')"
                    class="column is-4 is-marginless">
                    <b-input v-model="domiciliationBancaire.compteEscompteTva"></b-input>
                  </b-field>
                  <b-field
                    :label="$t('addDomiciliationBancaire.informationDomiciliation.SEPA')"
                    class="column is-4 is-marginless">
                    <b-input v-model="domiciliationBancaire.ribSepaId"></b-input>
                  </b-field>
                  <b-field class="column is-4">
                    <b-checkbox v-model="domiciliationBancaire.actif">
                      <p class="is-default">
                        {{ $t('addDomiciliationBancaire.informationDomiciliation.actif')}}
                      </p>
                    </b-checkbox>
                  </b-field>
                  <b-field class="column is-4">
                    <b-checkbox v-model="domiciliationBancaire.interfaceComptable">
                      <p class="is-default">
                        {{
                        $t('addDomiciliationBancaire.informationDomiciliation.interfaceComptable')
                        }}
                      </p>
                    </b-checkbox>
                  </b-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-multiline">
      <div class="column is-6">
        <div class="card mgt-20px">
          <parametrage-libelle-paiement-reglement :sens="sensVente"
                                                  :domiciliationBancaire="domiciliationBancaire"
                                                  @editInformation="edit">
          </parametrage-libelle-paiement-reglement>
        </div>
      </div>
      <div class="column is-6">
        <div class="card mgt-20px">
          <parametrage-libelle-paiement-reglement :sens="sensAchat"
                                                  :domiciliationBancaire="domiciliationBancaire"
                                                  @editInformation="edit">
          </parametrage-libelle-paiement-reglement>
        </div>
      </div>
      <div class="column is-12">
        <dom-bancaire-reglement :domiciliation-bancaire="domiciliationBancaire">
        </dom-bancaire-reglement>
      </div>
      <div class="column is-12">
        <positionnement-cheque :positionnement="domiciliationBancaire.positionnement">
        </positionnement-cheque>
      </div>
    </div>
    <b-modal v-model="showEdit" has-modal-card class="modal">
      <Edit :value="valueTmp"
            :type="typeEdit"
            :isReference="isReference"
            :sens="sens"
            @close="closeEdit"
            @save="getValue"/>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { get, create, update } from '@/api/domiciliationBancaire/index';
import genererDomiciliationBancaire from '@/services/parametrage/generation/genererDomiciliationBancaire';
import messageErreur from '@/services/general/messageErreur';
import messageSuccess from '@/services/general/messageSucces';
import breadcrumb from '@/components/general/breadcrumb';
import validation from '@/services/parametrage/validation/validationDomiciliationBancaire';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/parametrage/translator/translatorDomicialiationBancaire';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import Edit from '@/components/parametrage/domiciliationBancaire/addEdit/p_edit';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import parametrageLibellePaiementReglement
  from '@/components/parametrage/domiciliationBancaire/addEdit/parametrageLibellePaiementReglement';
import { SENS_ACHAT, SENS_VENTE } from '@/configuration/devisConf';
import domBancaireReglement from '@/components/parametrage/domiciliationBancaire/addEdit/domBancaireReglement';
import positionnementCheque from '@/components/parametrage/domiciliationBancaire/addEdit/positionnementCheque';
import inputIban from '@/components/general/inputIban';

const Parametres = createNamespacedHelpers('parametres');
const societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      error: false,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      domiciliationBancaire: null,
      showEdit: false,
      valueTmp: '',
      typeEdit: '',
      sensVente: SENS_VENTE,
      sensAchat: SENS_ACHAT,
      sens: null,
      isReference: false,
      libelle: '',
    };
  },
  computed: {
    getTitle() {
      if (this.$route.params.id) return this.$i18n.t('addDomiciliationBancaire.titleEdit', { libelle: this.libelle });
      return this.$i18n.t('addDomiciliationBancaire.titleAdd');
    },
    breadcrumb() {
      return [
        { title: this.$t('parametrage.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('parametrage.title'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('listeDomiciliationBancaire.title'), route: { name: 'l.parametrage.domiciliation_bancaire' }, isActive: false },
        { title: this.getTitle, route: { name: '' }, isActive: true },
      ];
    },
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreForce: 'loadParametreForce',
    }),
    async saveDomiciliationBancaire() {
      const loadingComponent = this.$buefy.loading.open();
      let domiciliationBancaire = null;
      try {
        this.error = false;
        this.messages = [];
        this.messagesChampsVide = [];
        this.champsVide = [];
        if (this.$route.params.id) {
          domiciliationBancaire = (await update(this.domiciliationBancaire)).data.result;
          messageSuccess(this.$i18n.t('addDomiciliationBancaire.success.edit'));
        } else {
          this.domiciliationBancaire.societeId = this.societeActiveId;
          domiciliationBancaire = (await create(this.domiciliationBancaire)).data.result;
          messageSuccess(this.$i18n.t('addDomiciliationBancaire.success.add'));
        }
        await this.loadParametreForce(typesParametres.PARAMETRES_KEYS.domiciliationBancaire);
        await this.$router.push({ name: 'c.parametrage.domiciliation_bancaire', params: { id: domiciliationBancaire.id } });
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error) {
          validation(e.response, this.messages);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    edit(type, value, sens, isReference) {
      this.typeEdit = type;
      this.valueTmp = value !== null ? value : '';
      this.sens = sens;
      this.showEdit = true;
      this.isReference = isReference;
    },
    closeEdit() {
      this.typeEdit = '';
      this.valueTmp = '';
      this.sens = null;
    },
    getValue(libelle) {
      if (libelle.type === 'ecriture') {
        if (this.sens === SENS_VENTE) {
          this.domiciliationBancaire.libelleEcritureReglement = libelle.value;
        } else this.domiciliationBancaire.libelleEcriturePaiement = libelle.value;
      }
      if (libelle.type === 'ecritureTiers') {
        if (this.sens === SENS_VENTE) {
          this.domiciliationBancaire.libelleLigneEcritureReglementTiers = libelle.value;
        } else this.domiciliationBancaire.libelleLigneEcriturePaiementTiers = libelle.value;
      }
      if (libelle.type === 'ecritureBanque') {
        if (this.sens === SENS_VENTE) {
          this.domiciliationBancaire.libelleLigneEcritureReglementBanque = libelle.value;
        } else this.domiciliationBancaire.libelleLigneEcriturePaiementBanque = libelle.value;
      }
      if (libelle.type === 'referenceTiers') {
        if (this.sens === SENS_VENTE) {
          this.domiciliationBancaire.libelleReferenceReglementTiers = libelle.value;
        } else this.domiciliationBancaire.libelleReferencePaiementTiers = libelle.value;
      }
      if (libelle.type === 'referenceBanque') {
        if (this.sens === SENS_VENTE) {
          this.domiciliationBancaire.libelleReferenceReglementBanque = libelle.value;
        } else this.domiciliationBancaire.libelleReferencePaiementBanque = libelle.value;
      }
    },
  },
  components: {
    appBreadcrumb: breadcrumb,
    Edit,
    errorMsgComponent,
    parametrageLibellePaiementReglement,
    domBancaireReglement,
    positionnementCheque,
    inputIban,
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.$route.params.id) {
        this.domiciliationBancaire = (await get(this.$route.params.id)).data.result;
        this.libelle = cloneDeep(this.domiciliationBancaire.libelle);
        this.setInformationPage(this.$t('pageGeneral.modification', { item: this.domiciliationBancaire.libelle }));
      } else {
        this.domiciliationBancaire = genererDomiciliationBancaire();
        this.setInformationPage(this.$t('pageParametrage.domiciliationBancaire.creation'));
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
